import React from "react";

const RestoreV2Icon16pxSvg = ({
    color = "#1F2937",
    width = 16,
    height = 16,
    ...props
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M13.6134 8.14665C13.3401 8.14665 13.1134 7.91998 13.1134 7.64665V5.43335C13.1134 4.60668 12.4401 3.93335 11.6134 3.93335H2.38672C2.11339 3.93335 1.88672 3.70668 1.88672 3.43335C1.88672 3.16002 2.11339 2.93335 2.38672 2.93335H11.6134C12.9934 2.93335 14.1134 4.05335 14.1134 5.43335V7.64665C14.1134 7.92665 13.8867 8.14665 13.6134 8.14665Z" fill={color} />
            <path d="M4.49339 6.04665C4.36672 6.04665 4.24006 5.99996 4.14006 5.89996L2.03339 3.79332C1.94005 3.69998 1.88672 3.5733 1.88672 3.43996C1.88672 3.30663 1.94005 3.17998 2.03339 3.08665L4.14006 0.979961C4.33339 0.786628 4.65339 0.786628 4.84672 0.979961C5.04005 1.17329 5.04005 1.49333 4.84672 1.68667L3.0934 3.43996L4.84672 5.1933C5.04005 5.38663 5.04005 5.70663 4.84672 5.89996C4.74672 5.9933 4.62005 6.04665 4.49339 6.04665Z" fill={color} />
            <path d="M13.6134 13.06H4.38672C3.00672 13.06 1.88672 11.94 1.88672 10.56V8.34668C1.88672 8.07335 2.11339 7.84668 2.38672 7.84668C2.66005 7.84668 2.88672 8.07335 2.88672 8.34668V10.56C2.88672 11.3867 3.56005 12.06 4.38672 12.06H13.6134C13.8867 12.06 14.1134 12.2867 14.1134 12.56C14.1134 12.8334 13.8867 13.06 13.6134 13.06Z" fill={color} />
            <path d="M11.5069 15.1666C11.3802 15.1666 11.2535 15.12 11.1535 15.02C10.9602 14.8266 10.9602 14.5066 11.1535 14.3133L12.9069 12.56L11.1535 10.8066C10.9602 10.6133 10.9602 10.2933 11.1535 10.1C11.3469 9.90662 11.6669 9.90662 11.8602 10.1L13.9669 12.2066C14.0602 12.2999 14.1135 12.4266 14.1135 12.56C14.1135 12.6933 14.0602 12.8199 13.9669 12.9133L11.8602 15.02C11.7669 15.12 11.6402 15.1666 11.5069 15.1666Z"  fill={color} />
        </svg>
    );
};

export default RestoreV2Icon16pxSvg;